import React, { useState } from 'react';
import { Video, Download, Calendar, Clock } from 'lucide-react';
import { Recording } from '../../../types/meeting';
import { formatDate } from '../../../utils/formatters';
import RecordingDetails from './RecordingDetails';

interface MeetingRecordingsProps {
  recordings: Recording[];
}

export default function MeetingRecordings({ recordings }: MeetingRecordingsProps) {
  const [selectedRecording, setSelectedRecording] = useState<string | null>(null);

  const handleDownload = (recordingId: string) => {
    // In a real app, this would trigger the recording download
    console.log(`Downloading recording ${recordingId}`);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">Recent Recordings</h3>
      </div>

      {recordings.length === 0 ? (
        <div className="p-6 text-center">
          <Video className="w-12 h-12 text-gray-400 mx-auto mb-2" />
          <p className="text-gray-500">No recordings available</p>
        </div>
      ) : (
        <div className="divide-y divide-gray-200">
          {recordings.map((recording) => (
            <div key={recording.id} className="p-4 hover:bg-gray-50">
              <div className="flex items-center justify-between">
                <div>
                  <h4 className="text-sm font-medium text-gray-900 cursor-pointer hover:text-blue-600"
                      onClick={() => setSelectedRecording(recording.id)}>
                    {recording.topic}
                  </h4>
                  <div className="mt-1 flex items-center space-x-4 text-sm text-gray-500">
                    <span className="flex items-center">
                      <Calendar className="w-4 h-4 mr-1" />
                      {formatDate(recording.recordingDate)}
                    </span>
                    <span className="flex items-center">
                      <Clock className="w-4 h-4 mr-1" />
                      {recording.duration} minutes
                    </span>
                  </div>
                </div>
                <button
                  onClick={() => handleDownload(recording.id)}
                  className="p-2 text-gray-400 hover:text-gray-600"
                >
                  <Download className="w-5 h-5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {selectedRecording && (
        <RecordingDetails
          recordingId={selectedRecording}
          onClose={() => setSelectedRecording(null)}
        />
      )}
    </div>
  );
}